const config = {
   env: 'DEV',
   PHONE: '',
   API: 'https://api-book.dtpsoft.vn/api/affiliate',
   HREF: 'https://sale-book.dtpsoft.vn',
}
export default config
